import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Balance } from '../models/balance';
import { GetBalanceResponse } from '../responses/GetBalanceResponse';
import { EndpointService } from './endpoint.service';
import { BudgetType } from '../helpers/constants';
import { BalanceHistoryRequest } from '../requests/BalanceHistoryRequest';
import { GetBalanceHistoryResponse } from '../responses/GetBalanceHistoryResponse';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {

  constructor(private http: HttpClient,
  ) { }

  public getLastUserBalance(userId: string): Observable<GetBalanceResponse> {
    return this.http.post<GetBalanceResponse>(EndpointService.getUserBalance + `?userId=${userId}`, {});
  }

  public getLastManualBalance(userId: string, budgetType: BudgetType): Observable<GetBalanceResponse> {
    return this.http.post<GetBalanceResponse>(EndpointService.getUserLastManualBalance + `?userId=${userId}`, budgetType);
  }
  public getLastOrderedTicketsHistoryBalance(userId: string, data: BalanceHistoryRequest): Observable<GetBalanceHistoryResponse> {
    return this.http.post<GetBalanceHistoryResponse>(EndpointService.getUserOrderedTicketsBalanceHistory + `?userId=${userId}`, data);
  }
}
